
      var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgInfo3X = props => /*#__PURE__*/React.createElement("svg", _extends({
  height: 45,
  width: 48,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "2 2 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M21.2 12a9.2 9.2 0 1 1-18.4 0 9.2 9.2 0 0 1 18.4 0Z",
  fill: "var(--theme-light, #f9f3fb)",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 1.6
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.328 8.088c0-.852-.69-1.543-1.543-1.543a1.55 1.55 0 0 0-1.543 1.543 1.543 1.543 0 0 0 3.086 0ZM13.83 16.545a.442.442 0 0 0 .443-.442l-.008-.862a.442.442 0 0 0-.442-.441h-.441V10.89a.442.442 0 0 0-.442-.442h-2.771a.442.442 0 0 0-.442.442v.87c0 .244.198.441.442.441h.922v2.59h-.922a.442.442 0 0 0-.442.442v.87c0 .244.198.441.442.441h3.662Z",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg height=\"45\" width=\"48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"2 2 20 20\"> <path d=\"M21.2 12C21.2 17.081 17.081 21.2 12 21.2C6.91898 21.2 2.8 17.081 2.8 12C2.8 6.91898 6.91898 2.8 12 2.8C17.081 2.8 21.2 6.91898 21.2 12Z\" fill=\"var(--theme-light, #f9f3fb)\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"1.6\"></path> <path d=\"M13.3279 8.08833C13.3279 7.2362 12.6371 6.54541 11.785 6.54541C10.9345 6.54938 10.246 7.23785 10.2421 8.08833C10.2421 8.94046 10.9329 9.63125 11.785 9.63125C12.6371 9.63125 13.3279 8.94046 13.3279 8.08833Z\" fill=\"var(--theme-primary, #810ea9)\"></path> <path d=\"M13.8306 16.5454C14.0747 16.5454 14.2725 16.3476 14.2725 16.1035L14.2653 15.2415C14.2653 14.9975 14.0674 14.7997 13.8234 14.7997H13.3815L13.3816 10.8913C13.3816 10.6473 13.1838 10.4494 12.9398 10.4494H10.169C9.92498 10.4494 9.72715 10.6473 9.72715 10.8913V11.7606C9.72715 12.0046 9.92498 12.2024 10.169 12.2024H11.0908L11.0907 14.7924H10.1689C9.92488 14.7924 9.72705 14.9903 9.72705 15.2343V16.1035C9.72705 16.3476 9.92488 16.5454 10.1689 16.5454H13.8306Z\" fill=\"var(--theme-primary, #810ea9)\"></path>     \r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/info@3x.4e217b267249777af6bf7fa30a9285d2.svg"),
        {
          React: SvgInfo3X,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      